import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Spinner from 'react-spinner-material';

import { FaFilter } from 'react-icons/fa';
import { MdImportExport } from 'react-icons/md';

import "react-table/react-table.css";
import "../css/style.css";

import { DATA_TYPE_CHANGE } from '../constants';
import MenuComponent2 from './MenuComponent2';
import ChangedWoListView from './ChangedWoListView';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import UserDataService from '../services/UserDataService';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR} from '../icon';

class ProductList extends Component {
  constructor () {
    super();
    const numOfMonths = 24;
    var fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000*3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    var toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      spinnerVisible: false,
      allStatus: [],
      fromDate: fromDate,
      toDate: toDate,
      workOrders: [],
      childRefreshCount: 0,
      countries: []
    };
  }

  loadCountries(){
    MasterDataService.retrieveCountryMappings().then(data => {
      if (data !== undefined && data !== null && data instanceof Array){
        let countries = [];
        for(let i=0; i< data.length; i++){
          let code = data[i].code;
          countries.push({
            id: code,
            name: code
          });
        }
        this.setState({ countries:  countries})
      } 
    });
  }

  componentDidMount () {
    this.loadCountries();
    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ allStatus:  data}) 
    });

    let fromDate = this.getItem("fromDate");
    let toDate = this.getItem("toDate");
    const numOfMonths = 24;
    if (fromDate === null || fromDate === undefined) {
      fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000*3);//1 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date();
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    this.setState({ 
      fromDate:  fromDate, 
      toDate: toDate, 
      status: this.getItem("status"), 
      country: this.getItem("country"),
      customer: this.getItem("customer"),
      orderNo: this.getItem("orderNo"),
      woStatus: this.getItem("woStatus")
    }, () => {
      this.filterOrdersBy();
    });       
    
  }

  toggleRow(id) {
		const newSelected = Object.assign({}, this.state.selected);
		newSelected[id] = !this.state.selected[id];
		this.setState({
			selected: newSelected,
			selectAll: 2
		});
	}

  getItem (key) {
    let value = sessionStorage.getItem(key);
    return value === null || value === '' || value === 'null' ? undefined: value
  }
  saveItem(key, value){
    if (value !== undefined && value !== 'null' && value !== ''){
      sessionStorage.setItem(key, value);
    }
  }  
  clearSearchInfo() {
    sessionStorage.removeItem("fromDate")
    sessionStorage.removeItem("toDate")
    sessionStorage.removeItem("status")
    sessionStorage.removeItem("country")
    sessionStorage.removeItem("customer")
    sessionStorage.removeItem("orderNo")
    sessionStorage.removeItem("woStatus")

  }
  saveSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus){
    sessionStorage.setItem("fromDate", fromDate);
    sessionStorage.setItem("toDate", toDate);  
    this.saveItem("status", status);
    this.saveItem("country", country);
    this.saveItem("customer", customer);
    this.saveItem("orderNo", orderNo);
    this.saveItem("woStatus", woStatus);
  }

  onFilter() {
    this.clearSearchInfo();
    this.filterOrdersBy();
  }

  filterOrdersBy(){   
    var fromDate = this.state.fromDate;
    var toDate = this.state.toDate;
    var status = this.state.status;
    var woStatus = this.state.woStatus;
    var country = this.state.country;
    var customer = this.state.customer;
    var orderNo = this.state.filteredOrderNo;
    let c = this.state.childRefreshCount + 1

    let isChanged = 1;
    let isFull = 1;
    WorkOrderDataService.retrieveWorkOrdersBy(fromDate, toDate, status, country, customer, orderNo, woStatus, isChanged, isFull)
      .then(data => {
      if(data.message === undefined && data instanceof Array){
        this.setState({ workOrders:  data, childRefreshCount: c});
        this.saveSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus);
      }else{
        this.setState({ workOrders:  []});
        ToastsStore.error(data.message);
      }   
    });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  exportExcel(){
    try
    {
      UserDataService.retrieveNextFilename(DATA_TYPE_CHANGE).then(res => {
        this.setState({spinnerVisible: true}, () =>{
          let selectedItems = [];
          if ((this.state.selectedWorkOrders !== undefined) && (this.state.selectedWorkOrders !== null)) {
            for (let key in this.state.selectedWorkOrders) {
              if (this.state.selectedWorkOrders[key] === true){
                selectedItems.push(parseInt(key));
              }
            }
          }
          console.log("[selectedItems]: ", selectedItems);
          WorkOrderDataService.exportExcel(selectedItems, res.filename, res.id).then(data =>{
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', res.filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});    
          });
        });
      });        
    } catch(e) {
        this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
    }        
  }

  getStatusDescription(status) {
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return status;
    }    
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x =>{
      return x.status === istatus;
    });
    if (statusInfo !== undefined){
      return statusInfo.statusDescVn;
    }   
    return status;    
  }

  handleFromDateChange(date){
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      fromDate: sDate                   
    }));
  }

  handleToDateChange(date){
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      toDate: sDate                   
    }));
  }

  handleStatusChange(e){
    var value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({                 
      status: value                   
    }));
  }

  handleWoStatusChange(e){
    var value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({                 
      woStatus: value                   
    }));
  }

  handleCountryChange(e){
    var value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({                 
      country: value                   
    }));
  }

  handleCustomerChange(e){
    var value = e.target.value;
    this.setState(prevState => ({                 
      customer: value                   
    }));
  }

  handleOrderNoChange(e){
    var value = e.target.value;
    this.setState(prevState => ({                 
      filteredOrderNo: value                   
    }));
  }

  renderStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }
    return(
      <select onChange={this.handleStatusChange.bind(this)} 
        value={ this.state.status }>
        <option value="all">{couterpart.translate('workorder_status_all')}</option>
        { this.state.allStatus.filter(y =>{
          return y.type === 1;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  renderWoStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }
     
    return(
      <select onChange={this.handleWoStatusChange.bind(this)} 
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        { this.state.allStatus.filter(y =>{
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  exportWorkOrders (infos) {
    this.setState({
      selectedWorkOrders: infos
    });
  }

  renderProductList () {
    if (this.state.workOrders.message !== undefined){
      return (<></>)
    }
    return (<ChangedWoListView workOrders={this.state.workOrders}  refreshCount={this.state.childRefreshCount} 
      parentCallback={ this.exportWorkOrders.bind(this) } 
      reloadCallback={ this.filterOrdersBy.bind(this) } />);
  }

  renderCountryList(){
    if (this.state.countries === undefined || this.state.countries === null){
        return (<></>);
    }
    return(
      <select onChange={this.handleCountryChange.bind(this)}
        value={this.state.country}>
        <option value="all">{couterpart.translate('order_country_all')}</option>
        { this.state.countries.map(x => <option value={x.name} key={x.name}>{x.name}</option>)}
      </select>
    );
  }    

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
      return (<div>Unauthorized access.</div>);
    }

    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <div  className="orderFilter">
                <label><b>{couterpart.translate('order_date_from')}</b></label>:&nbsp;
                <DatePicker name="orderDateFrom" 
                  dateFormat="MM/dd/yyyy hh:mm"              
                  selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                  onChange={this.handleFromDateChange.bind(this)}/>&nbsp;&nbsp;
                <label><b>{couterpart.translate('order_date_to')}</b></label>:&nbsp;
                <DatePicker name="orderDateTo" 
                  dateFormat="MM/dd/yyyy hh:mm"
                  selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                  onChange={this.handleToDateChange.bind(this)}/>&nbsp;&nbsp;
                <label><b>{couterpart.translate('work_order_country')}</b></label>:&nbsp;
                { this.renderCountryList() }<br/>
                <label><b>{couterpart.translate('orders')}</b></label>:&nbsp;
                { this.renderStatusList() }
                &nbsp;&nbsp;
                <label><b>{couterpart.translate('work_orders')}</b></label>:&nbsp;
                { this.renderWoStatusList() }
                <br/>
                <input type="text" defaultValue={this.state.customer}
                  placeholder={couterpart.translate('customer_name')}
                  onChange={this.handleCustomerChange.bind(this)}/>
                &nbsp;&nbsp;
                <input type="text" defaultValue={this.state.orderNo} 
                  placeholder={couterpart.translate('order_no')}
                  onChange={this.handleOrderNoChange.bind(this)}/>
                &nbsp;&nbsp;
                <button className="myButton" 
                  onClick={this.onFilter.bind(this)}>
                  <FaFilter color={ICON_COLOR}/>
                  &nbsp;{couterpart.translate('button_filter')}
                </button>&nbsp;&nbsp;
                <button className="myButton" 
                  onClick={this.exportExcel.bind(this)}>
                  <MdImportExport color={ICON_COLOR}/>
                  &nbsp;{couterpart.translate('button_export')}
                </button>              
              </div>
              { this.renderProductList() }
              <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
          </div>      
    )
  }
}
export default withRouter(ProductList);